module.exports = __webpack_public_path__ + "img/mileage.174678c6.png";